import { groupTransactionMarkers } from './transaction-screen-clusters';

// Shared DOM budget; retain each layer's independent counters and click contract.
export function groupLayerMarkers(features, map, aggregated = true) {
    const container = map.getContainer();
    return groupTransactionMarkers((features || []).map(feature => ({
        ...feature,
        properties: { ...feature.properties, count: feature.properties?.count ?? feature.properties?.signal_count ?? 1,
            sale_count: feature.properties?.sale_count ?? (feature.properties?.offer_type === 'sale' ? 1 : 0),
            rent_count: feature.properties?.rent_count ?? (feature.properties?.offer_type === 'rent' ? 1 : 0),
            investments_count: feature.properties?.investments_count ?? (feature.properties?.investment_id != null ? 1 : 0),
            aggregated: aggregated || feature.properties?.aggregated === true },
    })), coords => map.project(coords), container.clientWidth, container.clientHeight,
    ['sale_count', 'rent_count', 'pro_count', 'con_count', 'investments_count',
        'available_count', 'reserved_count', 'unknown_count']);
}
